import {
  TEDGAGravKontrollSTATUSEnum,
  TEDGAGravanordningStenStatusEnum,
  TEDInputGAGravKontrollAddValues,
} from '../../../../../../globalQueryTypes';

export const STATUS_LABELS: Record<TEDGAGravKontrollSTATUSEnum, string> = {
  [TEDGAGravKontrollSTATUSEnum.GODKAND]: 'Godkänd',
  [TEDGAGravKontrollSTATUSEnum.STOTTAD]: 'Stöttad',
  [TEDGAGravKontrollSTATUSEnum.NEDLAGD]: 'Nedlagd',
  [TEDGAGravKontrollSTATUSEnum.EJ_ATGARDAD]: 'Ej åtgärdad',
  [TEDGAGravKontrollSTATUSEnum.OVRIGT]: 'Övrigt',
};

export const STEN_STATUS_LABELS: Record<
  TEDGAGravanordningStenStatusEnum,
  string
> = {
  [TEDGAGravanordningStenStatusEnum.GODKAND]: 'Godkänd',
  [TEDGAGravanordningStenStatusEnum.EJ_GODKAND]: 'Ej godkänd',
};

const ANMARKNING_FALT = [
  { key: 'forKortaDubb', label: 'För korta dubb' },
  { key: 'forKraftigLutning', label: 'För kraftig lutning' },
  { key: 'forStoraHal', label: 'För stora hål' },
  { key: 'losaDelar', label: 'Lösa delar' },
  { key: 'sockelSaknas', label: 'Sockel saknas' },
  { key: 'ovrigaAnmarkningar', label: 'Övriga anmärkningar' },
] as const;

const ATGARD_TO_STATUS: Record<string, TEDGAGravKontrollSTATUSEnum> = {
  stottad: TEDGAGravKontrollSTATUSEnum.STOTTAD,
  nedlagd: TEDGAGravKontrollSTATUSEnum.NEDLAGD,
  ej_atgardad: TEDGAGravKontrollSTATUSEnum.EJ_ATGARDAD,
  ovrigt: TEDGAGravKontrollSTATUSEnum.OVRIGT,
};

export interface IInventeringFormState {
  inventeringStatus: 'godkand' | 'ej_godkand';
  atgard: string;
  forKortaDubb: boolean;
  forKraftigLutning: boolean;
  forStoraHal: boolean;
  losaDelar: boolean;
  sockelSaknas: boolean;
  ovrigaAnmarkningar: boolean;
  lutning: string;
  anteckningar: string;
}

export const buildAnmarkningar = (form: IInventeringFormState): string =>
  ANMARKNING_FALT.filter(({ key }) => form[key] === true)
    .map(({ label }) => label)
    .join(', ');

export const mapFormToKontrollValues = (
  form: IInventeringFormState,
  gravId: string,
  bildBlobId?: string
): TEDInputGAGravKontrollAddValues => {
  const status =
    form.inventeringStatus === 'godkand'
      ? TEDGAGravKontrollSTATUSEnum.GODKAND
      : ATGARD_TO_STATUS[form.atgard];

  const lutningTrimmad = form.lutning.trim();
  const lutningInt = lutningTrimmad ? parseInt(lutningTrimmad, 10) : NaN;
  const anmarkningar = buildAnmarkningar(form);

  return {
    DATUM: new Date().toISOString().slice(0, 10), // YYYY-MM-DD
    STATUS: status,
    LUTNING: Number.isFinite(lutningInt) ? lutningInt : undefined,
    NOTERING: form.anteckningar.trim() || undefined,
    ANMARKNINGAR: anmarkningar || undefined,
    _Associations: {
      Begravningsplats_Ref: gravId,
      Bild_Values: bildBlobId
        ? {
            BILD: bildBlobId,
            _Associations: {
              Begravningsplats_Ref: gravId,
            },
          }
        : undefined,
    },
  };
};
